<div class="modal-header">
  <h5 class="modal-title mb-0">Copy project</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('cancel')"></button>
</div>

<div class="modal-body">
  <app-sb-input-form
    mode="add"
    title="Copy project"
    submitLabel="Save"
    [showHeader]="false"
    [embedded]="true"
    (submitted)="saveProject()"
    (cancelled)="modal.dismiss('cancel')">
    @if (projectForm) {
    <div class="form-wraper" [formGroup]="projectForm">
      <div class="row">
        <div class="col-md-12 mb-3">
          <label class="form-label">Project title <span class="text-danger">*</span></label>
          <input
            class="form-control"
            placeholder="Project title"
            type="text"
            formControlName="title"
            ngbAutofocus
            (blur)="generateSlug();validateSlug();"
            [class.is-invalid]="submitted && f.title.errors"
          >
          @if (submitted && f.title.errors?.required) {
          <div class="invalid-feedback d-block">
            Project title is required
          </div>
          }
        </div>
        @if (currentUser()?.can('change-client', 'project')) {
        <div class="col-md-6 mb-3">
          <label class="form-label">Client</label>
          <app-auto-complete-select
            [hideLabel]="true"
            [isCreatable]="false"
            [onlyBottomBorder]="false"
            [placeholder]="'Select Client'"
            [selectOptions]="clientOptions()"
            (searchValue)="handleSearchValue($event)"
            (optionSelected)="handleClientSelection($event)"
            (scrollToEnd)="handleScroll()"
          ></app-auto-complete-select>
          @if (submitted && f.client_id.errors?.required) {
          <div class="invalid-feedback d-block">
            Client is required
          </div>
          }
        </div>
        }
        <div class="col-md-6 mb-3 customize-email d-flex align-items-center">
          <input id="with_influencers" placeholder="" type="checkbox" formControlName="with_influencers">
          <label for="with_influencers" class="mb-0">With influencers</label>
        </div>
      </div>
    </div>
    }
  </app-sb-input-form>
</div>
